import { createRouter, createWebHashHistory } from 'vue-router';
import { injectService } from '@patsnap/tahiti-core';
import { RouterProxy } from '@/services/router-proxy/router-proxy';
import { SharePageInterceptorService } from '@/services/share-page/share-page-interceptor-service';

const router = createRouter({
    history: createWebHashHistory(import.meta.env.VITE_BASE_URL),
    routes: [],
});

const installRouter = () => {
    const routerProxy = injectService<RouterProxy>(RouterProxy);
    const sharePageInterceptorService = injectService<SharePageInterceptorService>(SharePageInterceptorService);
    const { routes } = routerProxy.install();

    routes.forEach((route) => {
        router.addRoute(route);
    });

    sharePageInterceptorService.registerAxiosInterceptor();
};

export {
    router,
    installRouter,
};
